import { render, staticRenderFns } from "./CollectorAccountListFilter.vue?vue&type=template&id=3a56b101&"
import script from "./CollectorAccountListFilter.vue?vue&type=script&lang=js&"
export * from "./CollectorAccountListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports